import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = ["data-index"]
const _hoisted_3 = {
  key: 0,
  class: "r_nav"
}
const _hoisted_4 = ["id", "onClick"]

import menuTree from './menuTree1.vue';
import { onMounted, reactive, ref, toRaw } from 'vue';
type Menu = {
    Name: string,
    Children?: Menu[],
    ParentId: number,
    Id: number
}
type Props = {
    menuList: Menu[],
    index:number
    PageType :number,
    IsHome:number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'menuTree',
  props: {
    menuList: null,
    index: null,
    PageType: null,
    IsHome: null
  },
  emits: ['MenuTree'],
  setup(__props: any, { emit: emits }) {

const prop = __props as {
    menuList: Menu[],
    index:number
    PageType :number,
    IsHome:number
};

let person: any = reactive({
    IsChild:[],
    ClickId:0,
    Pid:0,
    index:0,
    width:0,
    menuActive:-1,
    riIndex:1,
    cache:''
})
const isChild = ref()

let prs = toRaw(prop)


onMounted(() => {
    inIntClick()
})
const goPage = (data:Menu[],Id:number,Pid:number,index:number) => {
    person.menuActive = Id
    person.isChild=data
    person.ClickId=Id
    person.Pid=Pid
    person.index=person.index+1
    var a= document.getElementsByClassName('r_item_title')
    for (let index = 0; index < a.length; index++) {
        const element = a[index];
        var di = element.getAttribute('data-index')
        if (Number(di) === Pid) {
            // person.width = element.scrollWidth // + 15
            // 获取元素
            let secMargin = getComputedStyle(element);
            // console.log('获取值', secMargin.marginRight);
            person.width = element.scrollWidth +parseFloat(secMargin.marginRight.replace('px',''))
            break;
        }
    }
    MenuTree1(Pid, person.ClickId, data, 0, index)
};
const inIntClick = () => {
    //取缓存
    if ((prop.PageType === 1 || prop.PageType === 2) && prop.IsHome === 0) {
        person.cache = localStorage.getItem('clickRecord')
    } else if ((prop.PageType === 3 || prop.PageType === 4) && prop.IsHome === 0) {
        person.cache = localStorage.getItem('clickRecord1')
    }
    if (person.cache !== '' && person.cache !== null) {
        var arr = JSON.parse(person.cache)
        prop.menuList[0].Children && prop.menuList[0].Children.forEach((x: any) => {
            var a = arr.filter((s: any) => s.key === x.Id)[0]
            if (a !== null && a !== undefined) {
                 goPage(a.value, a.key, a.Pid, 0)
            }
        })
    }
}
// 获取里层的方法
const MenuTree1 =(Pid:number,Id:number,item:any,riIndex:number,index:number)=>{
    emits('MenuTree', Pid, Id, item, riIndex, index);
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuList, (right, riIndex) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "r_item",
      style: 'width:100%;',
      key: riIndex
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "r_item_title",
          "data-index": right.Id
        }, _toDisplayString(right.Name) + ">", 9, _hoisted_2),
        (right.Children && right.Children.length>0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(right.Children, (chi, chiIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass(["r_nav_item", _unref(person).menuActive == chi.Id ?'r_nav_item_active':'']),
                  key: chiIndex,
                  id: chi.Id.toString(),
                  onClick: ($event: any) => (goPage(chi.Children, chi.Id, right.Id, chiIndex+1))
                }, _toDisplayString(chi.Name), 11, _hoisted_4))
              }), 128)),
              (_unref(person).isChild && _unref(person).isChild[0].ParentId == _unref(person).ClickId && right.Id==_unref(person).Pid)
                ? (_openBlock(), _createBlock(menuTree, {
                    key: 0,
                    width: _unref(person).width,
                    menuList: _unref(person).isChild,
                    index: 1,
                    Id: 0,
                    riIndex: _unref(person).riIndex,
                    PageType: _unref(prop).PageType,
                    IsHome: _unref(prop).IsHome,
                    onMenuTree1: MenuTree1
                  }, null, 8, ["width", "menuList", "riIndex", "PageType", "IsHome"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]))
  }), 128))
}
}

})